import Vue from 'vue';
import formatData from './utils/formatData';

Vue.filter('formatDate', function (date0) {
    return formatData.formatDate(date0)
})
